import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { API_URL } from '../config/api'
import './Contact.css'

function Contact() {
  const [searchParams] = useSearchParams()
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phonenumber: '',
    subject: '',
    carDetails: '',
    message: ''
  })
  const [cvFile, setCvFile] = useState(null)
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const isApplication = formData.subject.startsWith('Sollicitatie') || formData.subject === 'Spontane sollicitatie'

  useEffect(() => {
    const service = searchParams.get('service')
    if (service) {
      setFormData(prev => ({ ...prev, subject: service }))
    }
  }, [searchParams])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleCvChange = (e) => {
    const file = e.target.files[0] || null
    if (file && file.size > 5 * 1024 * 1024) {
      setError('CV mag maximaal 5 MB zijn.')
      e.target.value = ''
      return
    }
    setError(null)
    setCvFile(file)
  }

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = reject
    })

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)

    try {
      let cvBase64 = null
      let cvName = null
      if (cvFile) {
        cvBase64 = await toBase64(cvFile)
        cvName = cvFile.name
      }

      const response = await fetch(`${API_URL}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, cvBase64, cvName })
      })

      if (response.ok) {
        setSubmitted(true)
        setFormData({ name: '', email: '', phonenumber: '', subject: '', carDetails: '', message: '' })
        setCvFile(null)
        setTimeout(() => setSubmitted(false), 5000)
      } else {
        setError('Er is iets misgegaan. Probeer het opnieuw of bel ons.')
      }
    } catch {
      setError('Kan geen verbinding maken. Probeer het later opnieuw.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="contact">
      <h1>{isApplication ? 'Solliciteren' : 'Neem Contact Op'}</h1>
      <p className="subtitle">
        {isApplication ? 'Stuur ons jouw gegevens en CV.' : 'Vragen? We horen graag van je.'}
      </p>

      <div className="contact-container">
        <div className="contact-info">
          <div className="info-card">
            <h3>📍 Adres</h3>
            <p>Kortrijkseweg 361 D8<br />8791 Waregem</p>
          </div>
          <div className="info-card">
            <h3>📧 E-mail</h3>
            <p><a href="mailto:info@carwrapartist.be">info@carwrapartist.be</a></p>
          </div>
          <div className="info-card">
            <h3>📱 Telefoon</h3>
            <p><a href="tel:+32468457005">0468 45 70 05</a></p>
          </div>
          <div className="info-card">
            <h3>⏰ Openingsuren</h3>
            <p>Enkel op afspraak</p>
          </div>
        </div>

        <div className="contact-form-section">
          <form onSubmit={handleSubmit} className="contact-form">
            {submitted && (
              <div className="success-message">
                ✓ {isApplication ? 'Sollicitatie ontvangen! We nemen snel contact op.' : 'Dank je wel! We nemen binnenkort contact met je op.'}
              </div>
            )}
            {error && <div className="error-message">{error}</div>}

            <div className="form-group">
              <label htmlFor="name">Naam</label>
              <input type="text" id="name" name="name" value={formData.name}
                onChange={handleChange} required placeholder="Je naam" />
            </div>

            <div className="form-group">
              <label htmlFor="email">E-mail</label>
              <input type="email" id="email" name="email" value={formData.email}
                onChange={handleChange} required placeholder="jouw@email.com" />
            </div>

            <div className="form-group">
              <label htmlFor="phonenumber">Telefoonnummer</label>
              <input type="tel" id="phonenumber" name="phonenumber" value={formData.phonenumber}
                onChange={handleChange} required placeholder="jouw telefoonnummer" />
            </div>

            <div className="form-group">
              <label htmlFor="subject">Onderwerp</label>
              <input type="text" id="subject" name="subject" value={formData.subject}
                onChange={handleChange} required placeholder="Projectopvraag" />
            </div>

            {!isApplication && (
              <div className="form-group">
                <label htmlFor="carDetails">Auto Merk & Klasse</label>
                <input type="text" id="carDetails" name="carDetails" value={formData.carDetails}
                  onChange={handleChange} placeholder="bijv. BMW 3 Serie / Mercedes C-Klasse" />
              </div>
            )}

            <div className="form-group">
              <label htmlFor="message">
                {isApplication ? 'Motivatie' : 'Bericht'}
              </label>
              <textarea id="message" name="message" value={formData.message}
                onChange={handleChange} required rows="5"
                placeholder={isApplication ? 'Vertel ons waarom jij de geschikte kandidaat bent...' : 'Vertel ons over je project...'} />
            </div>

            {isApplication && (
              <div className="form-group">
                <label htmlFor="cv">CV uploaden <span className="label-hint">(PDF of Word, max 5 MB)</span></label>
                <div className="cv-upload-area">
                  <input type="file" id="cv" name="cv" accept=".pdf,.doc,.docx"
                    onChange={handleCvChange} />
                  {cvFile && (
                    <p className="cv-filename">📎 {cvFile.name}</p>
                  )}
                </div>
              </div>
            )}

            <button type="submit" className="btn-submit" disabled={loading}>
              {loading ? 'Verzenden...' : isApplication ? 'Sollicitatie Versturen' : 'Bericht Versturen'}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Contact
